import { TextBadgesClientWrapperProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TextBadges/__internal__/textBadgesClientWrapperProps";
import { TextBadgesProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TextBadges/textBadgesProps";

export const textBadgesClientWrapperAdaptor = (
  badgesProps: TextBadgesProps
): TextBadgesClientWrapperProps => {
  return {
    token: badgesProps.token,
    brandToken: badgesProps.brandToken,

    impressionId: badgesProps.impressionId,
    selectedProductOptionToken: badgesProps.selectedProductOptionToken,
    isPromoted: badgesProps.isPromoted,
    promotedBy: badgesProps.promotedBy,
    badgeList: badgesProps.badgeList,
    bestImage: badgesProps.bestImage,
    images: badgesProps.images,
  };
};
